export default __webpack_public_path__ + "static/media/Royal Aquilonian Brandy.84b15558.jpg";